// extracted by mini-css-extract-plugin
export default {"activity":"lzISME","fixedTextSize":"sOwaLZ","fixedActivityTextSize":"OX69QK","mobileTextSize":"VDSeo_"};